export default function firstStep(state = {}, action) {
  if (action.type === 'selectFirstStep') {
    return action.firstStep;
  }
  return state;
}